import { useCallback, useState, useRef, useLayoutEffect, useEffect } from "react";
import { useDebounce } from "./useDebounce";

export const DEFAULT_MAX_WIDTH = 512;

export const useMaxWidth = (
    fullWidth: boolean,
    defaultWidth: number = DEFAULT_MAX_WIDTH,
    multiplyWidth: number = 1,
): { maxWidth: string; elementRef: React.MutableRefObject<HTMLDivElement> } => {
    const [width, setWidth] = useState<number>(defaultWidth);
    const debouncedWidth = useDebounce((width * multiplyWidth).toString(), 1000);
    const elementRef = useRef<HTMLDivElement>();

    useLayoutEffect(() => {
        setWidth(elementRef.current?.offsetWidth || defaultWidth);
    }, [fullWidth]); // eslint-disable-line react-hooks/exhaustive-deps

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => handleResize(), [elementRef.current?.offsetWidth]);

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleResize = useCallback(() => {
        setWidth(elementRef.current?.offsetWidth || defaultWidth);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return {
        maxWidth: debouncedWidth,
        elementRef,
    };
};
